export enum PaymentMethodEnum {
  PSA_B2B_BNPL = 'psa_b2b_bnpl',
  ALLIANZ = 'allianz_trade_b2b_bnpl',
  BFS_B2B_BNPL = 'bfs_b2b_bnpl',
  HSBC = 'hsbc',
  CASH = 'cash',
  IVY = 'ivy',
  SWEDBANK_CREDITCARD = 'swedbank_creditcard',
  SWEDBANK_INVOICE = 'swedbank_invoice',
  SWEDBANK_VIPPS = 'vipps',
  SWEDBANK_MOBILE_PAY = 'mobile_pay',
  SWEDBANK_SWISH = 'swish',
  TRUSTLY = 'trustly',
  PAYPAL = 'paypal',
  PRZELEWY = 'przelewy24',
  SANTANDER_INSTANT = 'santander_instant',
  SANTANDER_INSTANT_AT = 'santander_instant_at',
  SANTANDER_INVOICE_AT = 'santander_invoice_at',
  SANTANDER_FACTORING_DE = 'santander_factoring_de',
  SANTANDER_POS_FACTORING_DE = 'santander_pos_factoring_de',
  SANTANDER_INSTALLMENT = 'santander_installment',
  SANTANDER_INSTALLMENT_AT = 'santander_installment_at',
  SANTANDER_INSTALLMENT_BE = 'santander_installment_be',
  SANTANDER_INSTALLMENT_DK = 'santander_installment_dk',
  SANTANDER_INSTALLMENT_NO = 'santander_installment_no',
  SANTANDER_INSTALLMENT_SE = 'santander_installment_se',
  SANTANDER_INVOICE_DE = 'santander_invoice_de',
  SANTANDER_INVOICE_NO = 'santander_invoice_no',
  SANTANDER_POS_INSTALLMENT = 'santander_pos_installment',
  SANTANDER_POS_INSTALLMENT_AT = 'santander_pos_installment_at', // Not used for now
  SANTANDER_POS_INSTALLMENT_DK = 'santander_pos_installment_dk',
  SANTANDER_POS_INSTALLMENT_NO = 'santander_pos_installment_no',
  SANTANDER_POS_INSTALLMENT_SE = 'santander_pos_installment_se',
  SANTANDER_POS_INSTALLMENT_UK = 'santander_pos_installment_uk',
  SANTANDER_POS_INVOICE_DE = 'santander_pos_invoice_de',
  SANTANDER_POS_INVOICE_NO = 'santander_pos_invoice_no',
  SANTANDER_INSTALLMENT_NL = 'santander_installment_nl',
  SANTANDER_INSTALLMENT_FI = 'santander_installment_fi',
  SANTANDER_POS_INSTALLMENT_FI = 'santander_pos_installment_fi',
  SANTANDER_INSTALLMENT_UK = 'santander_installment_uk',
  SOFORT = 'sofort',
  STRIPE = 'stripe',
  IDEAL = 'ideal',
  INSTANT_PAYMENT = 'instant_payment',
  APPLE_PAY = 'apple_pay',
  GOOGLE_PAY = 'google_pay',
  ZINIA_BNPL = 'zinia_bnpl',
  ZINIA_INSTALLMENT = 'zinia_installment',
  ZINIA_SLICE_THREE = 'zinia_slice_three',
  ZINIA_BNPL_DE = 'zinia_bnpl_de',
  ZINIA_POS_DE = 'zinia_pos_de',
  ZINIA_POS_SLICE_THREE = 'zinia_pos_slice_three',
  ZINIA_POS_SLICE_THREE_DE = 'zinia_pos_slice_three_de',
  ZINIA_POS_INSTALLMENT = 'zinia_pos_installment',
  ZINIA_POS_INSTALLMENT_DE = 'zinia_pos_installment_de',
  ZINIA_SLICE_THREE_DE = 'zinia_slice_three_de',
  ZINIA_INSTALLMENT_DE = 'zinia_installment_de',
  ZINIA_POS = 'zinia_pos',
  ECOCHEQUE = 'ecocheque',
  ZINIA_POS_LENDING_DE = 'zinia_pos_lending_de',
  ZINIA_LENDING_DE = 'zinia_lending_de',
  PAY_BY_BANK = 'pay_by_bank',
  VERIFONE_CREDITCARD = 'verifone_creditcard',
  BANCONTACT = 'bancontact',
  CREDIT_CARD = 'credit_card',
  DIRECT_DEBIT = 'direct_debit',
  BNPL = 'bnpl',
  TWINT = 'twint',
  BLIK = 'blik',
  EPS = 'eps',
  WERO = 'wero',
  BIZUM = 'bizum',
  RESURS_INSTALLMENT = 'resurs_installment',
  RESURS_POS_INSTALLMENT = 'resurs_pos_installment',
  RESURS_INVOICE = 'resurs_invoice',
  RESURS_POS_INVOICE = 'resurs_pos_invoice',
  PAYBACK = 'payback',
}

export enum PaymentIssuer {
  SODEXO = 'sodexo',
  EDENRED = 'edenred',
  MONIZZE = 'monizze',
  VERIFONE = 'verifone',
  STRIPE = 'stripe',
  PPRO = 'ppro',
  SWEDBANK = 'swedbank',
  GLOBAL_PAYMENTS = 'global_payments',
}

export enum PaymentMethodVariantEnum {
  Default = 'default',
  VariantTwo = 'v2',
  v3 = 'v3',
  v4 = 'v4',
  v5 = 'v5',
}
